import { render, staticRenderFns } from "./SubVendors.vue?vue&type=template&id=62d90602&"
import script from "./SubVendors.vue?vue&type=script&lang=js&"
export * from "./SubVendors.vue?vue&type=script&lang=js&"
import style0 from "./SubVendors.vue?vue&type=style&index=0&id=62d90602&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports